module.exports = __webpack_public_path__ + "static/ecommerce-playbook-3d-538ecc518bc9277d7cb427047d9e1a18.png";